import React from 'react';
import { ArrowRight, Package, Sparkles } from 'lucide-react';
import { kodujZZosia } from '../data/mock';

const Accessories = () => {
  const accessories = [
    {
      id: 1,
      name: "Koduj z Zosią",
      subtitle: "Interaktywne plansze",
      price: "799 zł",
      description: "10 wielkich map edukacyjnych + karty poleceń + naklejki. Rozszerz możliwości Zosi!",
      features: ["10 interaktywnych map", "32 karty poleceń", "96 naklejek", "2 puste mapy"],
      link: "https://sklep.eduko.pl/products/koduj-z-zosia-plansze-interaktywne",
      recommended: true
    },
    {
      id: 2,
      name: "Mata do kodowania",
      subtitle: "Duża 120x125cm",
      price: "290 zł",
      description: "100 pól do kodowania, idealna do pracy grupowej w przedszkolu i szkole podstawowej",
      features: ["100 pól 10x10cm", "Zmywalna", "Produkcja PL", "20 pól funkcyjnych"],
      link: "https://sklep.eduko.pl/products/mata-do-kodowania-koduj-z-eduko-duza-120x125cm",
      recommended: false
    },
    {
      id: 3,
      name: "Zmywalne mazaki",
      subtitle: "8 lub 12 sztuk",
      price: "od 40 zł",
      description: "Grube markery idealne do rysowania tras na matach i planszach",
      features: ["Zmywalne", "8 lub 12 kolorów", "Bezpieczne dla dzieci", "Do mat i plansz"],
      link: "https://sklep.eduko.pl/products/zmywalne-mazaki-crayola-8-szt",
      recommended: false
    }
  ];

  const bundles = [
    {
      name: "Zestaw MINI",
      price: "2 328 zł",
      description: "1x Zosia + Mata XXL + Plansze",
      savings: "Oszczędzasz 470 zł",
      link: "https://sklep.eduko.pl/products/zestaw-mini-robot-zosia-mata-do-kodowania-xxl-dlugopis-3d"
    },
    {
      name: "Zestaw START",
      price: "3 507 zł",
      description: "2x Zosia + Mata XXL + Plansze",
      savings: "Idealny dla małych grup",
      link: "https://sklep.eduko.pl/products/zestaw-start-2x-robot-zosia-2x-dlugopis-3d-mata-xxl-filament"
    },
    {
      name: "Zestaw TEAM",
      price: "6 155 zł",
      description: "4x Zosia + 2x Maty + Plansze",
      savings: "Dla całej klasy",
      link: "https://sklep.eduko.pl/products/zestaw-team-4x-robot-zosia-4x-dlugopis-3d-2x-mata-filament"
    }
  ];

  return (
    <section className="py-24 bg-gradient-to-b from-slate-50 to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl sm:text-5xl font-bold text-slate-900 mb-4">
            Rozszerz{' '}
            <span className="bg-gradient-to-r from-orange-600 to-amber-600 bg-clip-text text-transparent">
              możliwości Zosi
            </span>
          </h2>
          <p className="text-xl text-slate-600 max-w-3xl mx-auto">
            Dodatkowe plansze, maty i akcesoria - maksymalizuj potencjał edukacyjny
          </p>
        </div>

        {/* Accessories grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16">
          {accessories.map((item) => (
            <div
              key={item.id}
              className={`relative bg-white rounded-3xl p-8 hover:shadow-2xl transition-all duration-300 border-2 ${
                item.recommended ? 'border-orange-500' : 'border-slate-100'
              }`}
            >
              {item.recommended && (
                <div className="absolute -top-4 left-1/2 transform -translate-x-1/2 px-4 py-1 bg-gradient-to-r from-orange-500 to-amber-500 rounded-full text-white text-sm font-bold shadow-lg">
                  POLECAMY
                </div>
              )}

              <div className="flex items-center justify-between mb-4">
                <Package className="w-10 h-10 text-orange-500" />
                <span className="text-2xl font-bold text-orange-600">{item.price}</span>
              </div>

              <h3 className="text-2xl font-bold text-slate-900 mb-1">{item.name}</h3>
              <p className="text-sm text-slate-500 mb-4">{item.subtitle}</p>
              <p className="text-slate-600 mb-6">{item.description}</p>

              <ul className="space-y-2 mb-6">
                {item.features.map((feature, idx) => (
                  <li key={idx} className="flex items-center text-sm text-slate-600">
                    <Sparkles className="w-4 h-4 text-orange-500 mr-2 flex-shrink-0" />
                    {feature}
                  </li>
                ))}
              </ul>

              <a
                href={item.link}
                target="_blank"
                rel="noopener noreferrer"
                className={`block w-full text-center py-3 rounded-xl font-medium transition-all duration-300 ${
                  item.recommended
                    ? 'bg-gradient-to-r from-orange-500 to-amber-500 hover:from-orange-600 hover:to-amber-600 text-white shadow-lg hover:shadow-xl'
                    : 'bg-slate-100 hover:bg-slate-200 text-slate-900'
                }`}
              >
                Zobacz w sklepie
              </a>
            </div>
          ))}
        </div>

        {/* Bundles section */}
        <div className="bg-gradient-to-br from-orange-500 to-amber-500 rounded-3xl p-8 sm:p-12 text-white">
          <div className="text-center mb-8">
            <h3 className="text-3xl font-bold mb-3">Zestawy dla placówek</h3>
            <p className="text-orange-50 text-lg">
              Gotowe pakiety z rabatami - idealne dla przedszkoli i szkół
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {bundles.map((bundle, idx) => (
              <div
                key={idx}
                className="bg-white/10 backdrop-blur-sm rounded-2xl p-6 hover:bg-white/20 transition-all duration-300"
              >
                <h4 className="text-xl font-bold mb-2">{bundle.name}</h4>
                <p className="text-3xl font-bold mb-3">{bundle.price}</p>
                <p className="text-orange-50 text-sm mb-3">{bundle.description}</p>
                <p className="text-xs text-orange-100 mb-4">💰 {bundle.savings}</p>
                <a
                  href={bundle.link}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center space-x-2 text-white hover:text-orange-100 transition-colors font-medium"
                >
                  <span>Zobacz szczegóły</span>
                  <ArrowRight className="w-4 h-4" />
                </a>
              </div>
            ))}
          </div>

          <div className="mt-8 text-center">
            <a
              href="https://sklep.eduko.pl/collections/robotyka"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center space-x-2 px-6 py-3 bg-white text-orange-600 rounded-xl font-medium hover:bg-orange-50 transition-colors"
            >
              <span>Wszystkie zestawy w sklepie</span>
              <ArrowRight className="w-5 h-5" />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Accessories;
